/**
 * LINK
 * Button of type link (underlined)
 */
import { IconDefinition } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"

interface OwnProps {
  children: any //Content inside
  icon?: IconDefinition
  isWithoutMargin?: boolean //No margin
  isWhite?: boolean //Display text in white
  onClick?: Function //Action onClick
  isUnderline?: boolean //Underline text
  className?: string //custom className
}

function Link(props: OwnProps) {
  //Action on clic
  function click(e) {
    if (props.onClick) {
      props.onClick(e)
    }
  }

  //Style
  //White text if defined
  function getStyle() {
    let color
    let margin
    let textDecoration

    if (props.isWhite) color = "white"
    if (props.isWithoutMargin) margin = "0px"
    if (props.isUnderline === false) textDecoration = "none"

    return { color, margin, textDecoration }
  }

  return (
    <div className={`link grey-t ${props.className}`} onClick={(e) => click(e)} style={getStyle()}>
      {props.icon && <FontAwesomeIcon icon={props.icon} />}
      {props.children}
    </div>
  )
}

export default Link
